<div class="ui centered inline loader inverted massive">
  <img src="/assets/subscriptions/crown-white.svg" width="30" />
</div>
<div class="loader-content" *ngIf="!isProlongation && headerTextKey">
  <div class="header">{{ headerTextKey | translate }}</div>
  <div class="step-msg">{{ activeInitiatingText$.asObservable() | async | translate }}</div>
</div>
